export default __webpack_public_path__ + "static/media/default-video-image.ef917d96.webp";